define.alias("ember-intl/helpers/format-message", "media/helpers/format-message");